// extracted by mini-css-extract-plugin
module.exports = {"instructions":"style__instructions__wZKMY"};